import { useQuery } from '@tanstack/react-query';
import { api, GrSubscriptionResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseAdminSubscriptionsOptions {
  userId?: string;
  isActive?: boolean;
  tier?: string;
}

interface UseAdminSubscriptionsReturn {
  subscriptions: GrSubscriptionResponse[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useAdminSubscriptions(
  options: UseAdminSubscriptionsOptions = {},
): UseAdminSubscriptionsReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.adminSubscriptions(),
    queryFn: () =>
      api.listGameRewardsSubscriptions({
        userId: options.userId || undefined,
        isActive: options.isActive,
        tier: options.tier || undefined,
      }),
  });

  return {
    subscriptions: data?.subscriptions ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load subscriptions' : null,
    refresh: () => {
      refetch();
    },
  };
}
